import { useEffect, useRef } from "react"

export const useDisableDocumentScroll = (disable: boolean = true) => {
  // Store initial overflow styles
  const initialStyles = useRef({
    bodyOverflow: document.body.style.overflow,
    htmlOverflow: document.documentElement.style.overflow,
  });

  useEffect(() => {
    if (disable) {
      // Disable scrolling by setting overflow hidden
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      // Restore original overflow styles
      document.body.style.overflow = initialStyles.current.bodyOverflow;
      document.documentElement.style.overflow = initialStyles.current.htmlOverflow;
    }

    // Cleanup on unmount or when disable changes
    return () => {
      document.body.style.overflow = initialStyles.current.bodyOverflow;
      document.documentElement.style.overflow = initialStyles.current.htmlOverflow;
    };
  }, [disable]);

  return null; // Optional: return something if needed
}

// Helper hook to see what element is currently scrolling
export const useDebugWhatIsScrolling = () => {
  useEffect(() => {
    const handleScroll = (event: Event) => {
      let target = event.target as HTMLElement | Document
  
      if (target === document) {
        console.info("Scrolling on document")
      } else if (target instanceof HTMLElement) {
        console.info("Scrolling on element:", target)
        console.info("Element ID:", target.id)
        console.info("Element Classes:", target.className)
      }
    }
  
    document.addEventListener("scroll", handleScroll, true) // Captures bubbling events
  
    return () => {
      document.removeEventListener("scroll", handleScroll, true)
    }
  }, [])
}